import { render, staticRenderFns } from "./history-quoting-client.vue?vue&type=template&id=61945a7f&scoped=true"
import script from "./history-quoting-client.vue?vue&type=script&lang=js"
export * from "./history-quoting-client.vue?vue&type=script&lang=js"
import style0 from "./history-quoting-client.vue?vue&type=style&index=0&id=61945a7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61945a7f",
  null
  
)

export default component.exports